const TRANSLATIONS_ES = {
  // Common
  'Kanban'      : "Kanban",
  'List View'   : "Listado",
  'Settings'    : "Opciones",
  'Rename'      : "Renombrar",
  'Cancel'      : "Cancelar",
  'Create'      : "Crear",
  'status-desc' : "Estado",
  'View'        : "Ver",
  'Delete'      : "Eliminar",
  'Color'       : "Color",
  'Description' : "Descripción",
  'Unassigned'  : "Sin asignar",
  'Automatic'   : "Automática",
  'custom-f'    : "Personalizada",
  'User'        : "Usuario",
  'Percentage'  : "Porcentaje",
  'Save'        : "Guardar",
  '+ Add'       : "+ Agregar",
  'Remove'      : "Borrar",
  'Close'       : "Cerrar",
  'Confirm'     : "Confirmar",
  'Next'        : "Siguiente",
  'Back'        : "Anterior",
  'Get Started' : "Empezar",

  // Navigation
  'Leads'                   : "Leads",
  'Reports'                 : "Reportes",
  'Users'                   : "Usuarios",
  'Business'                : "Negocio",
  'User Management'         : "Manejo de usuarios",
  'Business Settings'       : "Opciones del negocio",
  'Switch Organization'     : "Cambiar organización",
  'Sign Out'                : "Cerrar sesión",
  'Profile & Notifications' : "Perfil y notificaciones",
  'Plan & Billing'          : "Plan y facturación",
  'Organization Settings'   : "Opciones de la organización",
  'Categories'              : "Categorías",
  'Archived'                : "Archivadas",

  // Auth
  'Log In'                     : "Iniciar sesión",
  'Email address'              : "Correo electrónico",
  'Password'                   : "Contraseña",
  'Forgot your password?'      : "Olvidaste tu contraseña?",
  'log-in-action'              : "Ingresar",
  'Sign Up'                    : "Registro",
  'sign-up-action'             : "Continuar",
  'have-account-login'         : "¿Ya tienes una cuenta? <1>Ingresa aquí</1>",
  'create-free-account'        : "¿No tienes una cuenta? <1>Crea tu cuenta gratuita</1>",
  'Language'                   : "Idioma",
  'Please enter a valid email' : "Ingresa un correo electrónico válido",
  'password-too-short'         : "La contraseña debe tener un mínimo de 6 caracteres",
  'First name'                 : "Nombre",
  'Last name'                  : "Apellido",
  'Change password'            : "Cambiar contraseña",
  'Change email'               : "Cambiar correo",
  'Save Changes'               : "Guardar cambios",
  'Profile Details'            : "Detalles del perfil",
  'Enter your old password'    : "Ingresa tu contraseña anterior",
  'Enter your new password'    : "Ingresa tu contraseña nueva",
  'verify-email-access'        : "Verifica que puedes ingresar a tu correo <1>{{ email }}</1> para no perder acceso a tu cuenta",
  'New email address'          : "Correo electrónico nuevo",
  'Change Email'               : "Cambiar correo",
  'Get started for free'       : "Regístrate de gratis",

  'Your old password will no longer work'                     : "Tu contraseña anterior dejará de funcionar",
  'You have unsaved changes for this user'                    : "Tienes cambios sin guardar para este usuario",
  'All notifications and updates will be sent to this email.' : "Las notificaciones y alertas se enviarán a este correo.",
  'You will use your new email to sign in'                    : "Usarás tu nuevo correo para ingresar",

  'Verify your email is typed correctly so you can receive important communications':
    "Verifica cuidadosamente tu correo nuevo para poder recibir comunicaciones importantes",

  // Users
  'Users & Roles'                                   : "Usuarios y roles",
  'Role'                                            : "Rol",
  'Organization Admin'                              : "Admin. de la organización",
  'Business Manager'                                : "Gestor de negocios",
  'Category Manager'                                : "Gestor de categorías",
  'Lead Manager'                                    : "Gestor de leads",
  'Invitation Expired'                              : "Invitación expirada",
  'Invitation Pending'                              : "Invitación pendiente",
  '＋ Add User'                                      : "＋ Agregar usuario",
  'Search by name or email'                         : "Buscar por nombre o correo",
  'No users match your search. <1>Clear search</1>' : "Ningún usuario coincide con su búsqueda. <1>Eliminar búsqueda</1>",
  'Select a role'                                   : "Seleccione un rol",

  'admin-role-desc'    : "Maneja todos los aspectos de la organización: facturación, usuarios, y negocios",
  'business-role-desc' : "Maneja los negocios y categorías seleccionadas",
  'category-role-desc' : "Maneja las categorías seleccionadas y sus leads",
  'lead-role-desc'     : "Únicamente puede ver, editar, y borrar leads asignados a su usuario",
  
  // API Errors
  'A user with this email already exists'                                     : "Ya existe un usuario asociado a este correo",
  'Enter a valid email address.'                                              : "Ingresa un correo electrónico válido.",
  'The request could not be processed. Please refresh this page or try again' : "No se pudo completar esta operación. Refresca esta página e intenta de nuevo",
  'Unable to log in with provided credentials.'                               : "Tu correo o contraseña son incorrectos.",

  // Lead Fields
  "Email"           : "Correo electrónico",
  "Phone"           : "Teléfono",
  "Name"            : "Nombre",
  "Full Name"       : "Nombre completo",
  "First Name"      : "Nombre",
  "Last Name"       : "Apellido",
  "Normalized Name" : "Nombre normalizado",
  "Street Address"  : "Dirección",
  "City"            : "Ciudad",
  "State"           : "Provincia / Estado",
  "Country"         : "País",
  "Zip Code"        : "Código postal",
  "Gender"          : "Género",
  "Birthdate"       : "Fecha de nacimiento",
  "Custom Fields"   : "Campos personalizados",
  "Lead"            : "Lead",
  "Date Added"      : "Fecha creado",
  "Assigned To"     : "Asignado a",
  "Status"          : "Etapa",
  "Source"          : "Fuente",
  'Last Updated'    : "Última actualización",
  
  // Leads
  'Add Lead'    : "Agregar lead",
  'Filters'     : "Filtros",
  'Add Filter'  : "Agregar filtro",
  'Edit Filter' : "Editar filtro",
  'contains'    : "contiene",
  'is'          : "es",

  // Dates
  'All Time'            : "Rango total",
  'Today'               : "Hoy",
  'Yesterday'           : "Ayer",
  'Today and yesterday' : "Hoy y ayer",
  'This week'           : "Esta semana",
  'Last week'           : "Semana anterior",
  'This month'          : "Este mes",
  'Last month'          : "Mes anterior",
  'Last 7 days'         : "Últimos 7 días",
  'Last 14 days'        : "Últimos 14 días",
  'Last 30 days'        : "Últimos 30 días",
  'Last 60 days'        : "Últimos 60 días",
  'Custom'              : "Personalizado",

  // Business
  'welcome-back'          : "Bienvenido de vuelta, {{name}}",
  'Current business'      : "Negocio actual",
  'Details'               : "Detalles",
  'x-leads_one'           : "{{count, number}} lead",
  'x-leads_other'         : "{{count, number}} leads",
  'Business name'         : "Nombre del negocio",
  '＋ Add Category'        : "＋ Agregar categoría",
  'Total Leads'           : "Leads total",
  'active-f'              : "Activa",
  'archived-f'            : "Archivada",
  'Category name updated' : "Nombre de la categoría actualizado",
  'New category created'  : "Nueva categoría creada",

  // Category
  'Category Settings'        : "Opciones de la categoría",
  'Category name'            : "Nombre de la categoría",
  'Default Status'           : "Etapa predeterminada",
  'Lead Status'              : "Etapas de los leads",
  '(optional)'               : "(opcional)",
  'Lead Distribution'        : "Distribución de leads",
  'Custom Lead Distribution' : "Distribución de leads personalizada",
  'Edit Distribution'        : "Modificar distribución",
  'remaining-percentage'     : "Porcentaje restante: <1>{{ percentage }}%</1>",
  '+ Add description'        : "+ Agregar descripción",
  '＋ Add Status'             : "＋ Agregar estapa",

  'Enter a number between 0 and 100'           : "Ingresa un número entre 0 y 100",
  'Enter a whole number (no decimals allowed)' : "Ingresa un número entero (sin decimales)",
  'Enter a valid number'                       : "Ingresa un número válido",
  
  'All incoming leads in this category will have this status assigned by default.':
    "Todos los leads que ingresen serán asignados a esta etapa.",
  
  'New incoming leads are not assigned to any user by default. Users will need to manually assign each lead.':
    "Los leads entrantes no serán asignados a ningún usuario. Los usuarios deben asignar cada lead manualmente.",

  'New incoming leads will be randomly assigned evenly between all users who are part of this category.' :
    "Los leads entrantes serán asignados aleatoriamente en porcentajes iguales entre todos los usuarios de la categoría",

  'Incoming leads will be assigned based on a custom distribution you define.':
    "Los leads entrantes serán asignados a la distribución personalizada que definas",

  'Make sure all percentages add up to 100%':
    "Asegúrate que los porcentajes sumen a un total del 100%",

  'Incoming leads will be assigned to users according to following percentages. <1>Learn more</1>':
    "Los leads entrantes se asignarán de acuerdo a los siguientes porcentajes. <1>Más información</1>",

  // Onboarding
  'Name your business'                 : "Nombra tu negocio",
  'Create your first category'         : "Crea tu primera categoría",
  "{{name}}'s Business"                : "Negocio de {{name}}",
  "{{name}}'s Leads"                   : "Leads de {{name}}",
  'Start with an empty category'       : "Comenzar con una categoría vacía",
  'Manually add or import your leads.' : "Agrega manualmente o importa tus propios leads.",
  'Play with a sample category'        : "Prueba con una categoría de muestra",
  'Setup complete!'                    : "¡Configuración lista!",

  'Enter a name for your business. You can edit it later in your Business Settings.':
    "Ingresa un nombre para tu negocio. Puedes editar este nombre luego en las opciones del negocio.",

  'Categories are used to classify your leads, e.g. <strong>Roofing</strong> or <strong>Dental Implants</strong>. All plans include unlimited categories.':
    "Las categorías se utilizan para clasificar tus leads. Por ejemplo, <strong>Implantes Dentales</strong>. Todos los planes pueden crear categorías ilimitadas.",

  'Add a few dummy leads to test out the look and feel of Precious Leads.':
    "Agrega unos leads de prueba para ver el diseño y estilo de Precios Leads.",

  'Enter a name for your new category. You can edit it later inside the Category’s Settings:':
    "Ingresa el nombre de tu nueva categoría. Podrás editarlo después en los ajuestes de la categoría:",

  'We will create a sample category with a few leads so that you can try and test out Precious Leads.':
    "Crearemos una categoría con leads de prueba para que puedas probar Precious Leads.",
}

export default TRANSLATIONS_ES;
